(function () {
  const productsFilters = (section) => {
    if (!section || !section.classList.contains('popular-products-section')) {
      return;
    }
    const filters = section.querySelectorAll('.filters__item');
    const wrappers = section.querySelectorAll('.popular-products__wrapper--filters');

    // Split out of the click handler so initialisation can select a tab WITHOUT
    // synthesizing a click. `firstTab.click()` dispatched a real bubbling event that the
    // section tracker in assets/analytics.js counted as a customer clicking: one phantom
    // section_clicked per mobile homepage load, which was most of this section's recorded
    // CTR (2183 'control' clicks vs 14 card clicks in the 30 days to 2026-09-21).
    const activate = (item) => {
      if (!item || !item.classList.contains('filters__item')) return;
      const filterTarget = item.dataset.filterTarget;

      filters.forEach((filterEl) => {
        filterEl.classList.remove('filters__item_active');
      });
      item.classList.add('filters__item_active');

      wrappers.forEach((wrapperEl) => {
        wrapperEl.classList.remove('active');
      });
      wrappers.forEach((wrapperEl) => {
        if (wrapperEl.dataset.filterTarget == filterTarget) {
          wrapperEl.classList.add('active');
        }
      });
    };

    const onToggleTab = (event) => {
      event.preventDefault();
      activate(event.currentTarget);
    };

    filters.forEach((item) => {
      item.addEventListener('click', onToggleTab);
    });

    // Guarded: a section configured with no filters left `filters[0]` undefined, and the
    // TypeError was invisible because exception capture is off (layout/theme.liquid).
    if (window.innerWidth < 768 && filters.length) activate(filters[0]);
  };

  productsFilters(document.currentScript.parentElement);

  document.addEventListener('shopify:section:load', function (event) {
    productsFilters(event.target);
  });
})();


// carousel
(function () {
  const allSliders = () => document.querySelectorAll('.popular-products__swiper');

  // Which carousels are actually on screen. The section renders one per filter category --
  // ten on the live homepage -- and `.popular-products__wrapper--filters` is display:none
  // without `.active`, so at any moment nine of them are hidden. offsetParent is null for a
  // display:none element; it is used in preference to checking for `.active` because the
  // non-filtered variant of this section renders a swiper that carries neither class.
  const visibleSliders = () =>
    Array.from(allSliders()).filter((slider) => slider.offsetParent !== null);

  const buildSlider = (slider) => {
    const wrapper = slider.closest('.popular-products__wrapper--filters');
    const paginationEl = wrapper
      ? wrapper.querySelector('.popular-products__pagination')
      : slider.querySelector('.popular-products__pagination');

    // Was `productSlider = new Swiper(...)` against a `let productSlider` in the enclosing
    // loop -- which this extraction left undeclared, i.e. an implicit global. The handle was
    // never read: `slider.swiper` is how Swiper exposes the instance and is what destroy
    // uses. So there is nothing to assign it to.
    new Swiper(slider, {
      navigation: {
        nextEl: ".popular-products__button-next",
        prevEl: ".popular-products__button-prev",
      },
      pagination: {
        el: paginationEl,
        type: 'fraction',
      },
      slidesPerView: 2,
      slidesPerGroup: 2,
      
      breakpoints: {
        0: {
          spaceBetween: 8,
          slidesPerView: 2,
          slidesPerGroup: 2,
          grid: {
            rows: 2,
            fill: 'row'
          },
        },
        768: {
          slidesPerView: 4,
          slidesPerGroup: 1,
          autoplay: false,
          grid: false,
          spaceBetween: 8,
        },
        1024: {
          slidesPerView: 5,
          slidesPerGroup: 1,
        }
      }
    });
  };

  const initSlider = () => allSliders().forEach(buildSlider);

  const destroySlider = () => {
    allSliders().forEach((slider) => {
      if (slider.swiper !== undefined) slider.swiper.destroy();
    });
  };

  // Destroy-then-build is kept as the mechanism, not removed: a carousel built while its
  // wrapper was display:none measured zero width, and rebuilding it once it is on screen is
  // what finally gives it real geometry. What changes is the SCOPE -- this used to run over
  // every slider in the document.
  const rebuild = (sliders) => {
    sliders.forEach((slider) => {
      if (slider.swiper !== undefined) slider.swiper.destroy();
      buildSlider(slider);
    });
  };

  // A resize used to tear down and rebuild all ten carousels. Every product image that
  // finishes loading changes the section's height, so that ran over and over during load,
  // against Script Evaluation already measured at 2516ms -- the largest single bucket of
  // 8.2s of main-thread work (Lighthouse, 2026-09-21). Nine of the ten rebuilt carousels
  // were hidden, so the work was wasted even when it was correct.
  //
  // Now: only what is on screen, and at most once per frame. ResizeObserver delivers a
  // burst of callbacks during load; coalescing them into a single frame collapses the burst
  // without delaying the rebuild the visible carousel actually needs.
  let pendingFrame = null;
  const onSectionResize = () => {
    if (pendingFrame !== null) return;
    pendingFrame = requestAnimationFrame(() => {
      pendingFrame = null;
      rebuild(visibleSliders());
    });
  };

  let sectionResizeObserver = null;

  const initSection = () => {
    const sections = document.querySelectorAll('.section__popular-products');

    // initSection() re-runs on every shopify:section:load. Without this the previous
    // observer stayed attached to the old nodes, so each edit in the theme editor added
    // another observer -- and another full rebuild per resize -- on top of the last.
    if (sectionResizeObserver) sectionResizeObserver.disconnect();
    sectionResizeObserver = new ResizeObserver(onSectionResize);

    destroySlider();
    initSlider();

    sections.forEach(item => {
      sectionResizeObserver.observe(item);
    });
  };

  initSection();

  document.addEventListener('shopify:section:load', function () {
    initSection();
  });
})();


